<script>
import CreditCard from "./CreditCard";
import Boleto from "./Boleto";

export default {
  components: {
    CreditCard,
    Boleto
  },

  props: {
    payments: {
      type: Array,
      required: true
    }
  },

  methods: {
    paymentType(payment) {
      return payment.funding_instrument.type === "credit_cards"
        ? "credit-card"
        : "boleto";
    }
  }
};
</script>

<template>
  <div v-if="payments" class="card">
    <div class="title mb-20">
      <div>pagamentos</div>
      <slot name="header-right"></slot>
    </div>

    <div v-if="!payments.length" class="not-exists">Nenhum pagamento realizado.</div>

    <component
      v-else
      v-for="payment in payments"
      :key="payment.id"
      :is="paymentType(payment)"
      :payment="payment"
    />
  </div>
</template>

<style scoped>
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.btn {
  margin: 0;
}

section:last-child {
  border-bottom: none;
}

@media (max-width: 540px) {
  .title {
    flex-direction: column;
    align-items: center;
  }

  .btn-go-to-checkout {
    margin-top: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/PaymentHistory/Index.vue